module.exports = __webpack_public_path__ + "static/img/116_TO8_1645.47bddf3.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/116_TO8_1645.jpg
// module id = fTZ+
// module chunks = 0